import { _ as t } from "../internals/export.js";
import { d as r } from "../internals/descriptors.js";
import { o } from "../internals/object-prototype-accessors-forced.js";
import { t as e } from "../internals/to-object.js";
import { t as s } from "../internals/to-property-key.js";
import { o as p } from "../internals/object-get-prototype-of.js";
import "../internals/object-get-own-property-descriptor.js";
import { __exports as i } from "../../../_virtual/object-get-own-property-descriptor.js";
var a = i.f;
r && t({
  target: "Object",
  proto: !0,
  forced: o
}, {
  __lookupSetter__: function __lookupSetter__(t) {
    var r,
      o = e(this),
      i = s(t);
    do if (r = a(o, i)) return r.set; while (o = p(o));
  }
});